import { createContext } from 'react'

export const AriaLiveContext = createContext()
